/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-login-card[_ngcontent-%COMP%]{position:relative;max-width:400px;left:50%;top:50%;transform:translate(-50%,-50%)}.picture-credit[_ngcontent-%COMP%]{position:absolute;top:2%;background-color:#000!important;color:#fff;text-decoration:none;padding:4px 6px;font-family:-apple-system,BlinkMacSystemFont,San Francisco,Helvetica Neue,Helvetica,Ubuntu,Roboto,Noto,Segoe UI,Arial,sans-serif;font-size:12px;font-weight:700;line-height:1.2;display:inline-block;border-radius:3px}nav[_ngcontent-%COMP%]{z-index:10000!important}"];
export { styles as styles };
